import React, { useState, useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";

const LinkCopyModal = ({ isOpen, toggle, url, nodeName }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);

  const handleCopy = () => {
    inputRef.current.select();
    document.execCommand("copy");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };

  const getValidUrl = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url; 
    }
    return url;
  };

  return (
    <Modal className="mt-15 mx-auto" isOpen={isOpen} toggle={toggle}>
      <ModalHeader className="modal-heading px-4 py-3" toggle={toggle}>Copy this URL for</ModalHeader>
      <ModalBody className="p-0">
        <div className="model-content">
          <p className="text-center p-2 mb-0">
            <a href={getValidUrl(url)} target="_blank" rel="noopener noreferrer" className="text-decoration-none fs-14">
              {nodeName}
            </a>
          </p>
        </div>
        <Input
          type="text"
          value={url}
          readOnly
          innerRef={inputRef}
          style={{ opacity: 0, height: 0, position: "absolute" }} // Hide the input field
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="create-button" onClick={handleCopy}>
          {copied ? "Copied!" : "Copy"}
        </Button>
        <Button
          color="secondary"
          onClick={toggle}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LinkCopyModal;
